import React, {useEffect, useState} from "react";
import FormatService from "../../services/format-service";
import HelperService from "../../services/helper-service";
import {BuildingStatTypes} from "../../utils/constants";

export default function BuildingStatYieldWidget({
                                                    stats,
                                                    buildingId=null,
                                                    widgetClass=null,
                                                    containerClass=null,
                                                    ...props
}) {

  const [statVal, setStatVal] = useState(null);


  useEffect(()=>{
    let buildingValueStat = HelperService.getObjByKey(Object.values(stats), 'type_sync_id', BuildingStatTypes.buildingValue.val);
    let rentStat = HelperService.getObjByKey(Object.values(stats), 'type_sync_id', BuildingStatTypes.rent.val);
    if (buildingValueStat?.last && rentStat?.last){
      let yieldStatVal = rentStat.last.stat * 4 / buildingValueStat.last.stat * 100;
      setStatVal(yieldStatVal);
    } else {
      setStatVal(null);
    }
  }, [stats]);

  return (
    <>
      {statVal && <div className={containerClass}><div className={widgetClass}>
        <div className="row">
          <div className="col-12 d-flex justify-content-between flex-wrap align-items-center">
            <h5>Výnosnosť prenájmu</h5>
            <h3>{FormatService.formatNumber(Math.round(((statVal+Number.EPSILON)*100))/100)} <span dangerouslySetInnerHTML={{ __html: '%' }}></span></h3>
          </div>
        </div>
      </div></div>}
    </>
  );
}
